import { Button } from 'primereact/button';

function ModalDeleteFooter({
  cancelBtnLabel,
  confirmBtnLabel,
  onCancel,
  onConfirm,
}: {
  cancelBtnLabel?: string;
  confirmBtnLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <>
      <Button label={cancelBtnLabel || 'Cancel'} icon="pi pi-times" size="small" text onClick={onCancel} />
      <Button
        label={confirmBtnLabel || 'Delete'}
        icon="pi pi-check"
        size="small"
        severity="danger"
        onClick={onConfirm}
      />
    </>
  );
}

export default ModalDeleteFooter;
